/**
 * Minimal demo scene for Echo Engine.
 *
 * It exercises the generic engine path — WebGPU device bring-up, the camera /
 * render service, and the per-frame render loop —  With no render
 * objects added, the render service clears the canvas each frame, proving the
 * device and loop are live.
 */

import Scene from "../../lib/services/scene/scene";
import DioramaCamera from "../../lib/services/scene/diorama_camera";
import Stage from "../../lib/services/stage/stage";
import Puppy from "./puppy/puppy";
import DioramaCameraControl from "../../lib/services/scene/diorama_camera_control";
import DioramaCameraPlacement from "../../lib/services/scene/diorama_camera_placement";
import Sky from "./sky/sky";
import Doghouse from "./doghouse/doghouse";
import SpatialMusic from "./music/spatial_music";
import PuppyCharacter from "./puppy/puppy_character";

export default class EchoDemoScene extends Scene {
  camera: DioramaCamera;
  camera_control:DioramaCameraControl;
  cam_placement:DioramaCameraPlacement;
  sky:Sky;
  doghouse:Doghouse;
  puppy:Puppy;
  puppy_char: PuppyCharacter;
  music:SpatialMusic;
  constructor() {
    super("echo-demo");


    //setting clear color to white, default is black (0,0,0,1)
    Stage.instance().render_service.set_clear_color(1,1,1,1);

    this.camera = new DioramaCamera();
    this.camera.set_target(0.0, 0.5, 2.8);
        this.camera.set_style_angle(Math.PI * 0.03, 0.08);
        this.camera.set_fov_y(Math.PI / 8.5);
        this.camera.set_distance(6.0);
        this.cam_placement = new DioramaCameraPlacement(this.camera);
        this.camera.set_distance_bounds(1.0,30.0);
        this.camera.set_distance(8.0);

        this.camera_control = new DioramaCameraControl(this.camera);
        this.camera_control.set_pan_bounds(-4.0, 4.0);
        this.camera_control.set_sensitivity(0.008, 0.010);
        this.camera_control.set_smoothing(0.25);

        this.music = new SpatialMusic("street_girl");
        this.add(this.music);

    //for 2D objects draw order is the instantiation order
    //instanced sky and clouds
      this.sky= new Sky("sky");
      this.add(this.sky); //add to the scene

      //doghouse
      this.doghouse= new Doghouse("doghouse");
      this.add(this.doghouse);//add to the scene

    //create puppy
    this.puppy = new Puppy ("puppy");
    //add puppy to the scene for tick() and rendering
    this.add(this.puppy);

    //second puppy uses the Character class that handles all the setup
     this.puppy_char = new PuppyCharacter ();
     this.add(this.puppy_char);

    // In-scene camera sticker scanner. The single Video SceneObject (which owns
    // its own scrim backdrop and scan-feedback overlays, and draws them in
    // order) is owned by StickerService, not the scene. Adding it here — as the
    // last integration step — keeps exactly one Video for the whole app so
    // scanning never spawns a duplicate camera. The scan flow
    // (StickerService.scan → SceneScanController → scan_start message) activates
    // it on demand.
    Stage.instance().sticker_service.add(this); ///fake comment
  }

  prepare(device: GPUDevice) {
    this.internal_prepare(device, this.camera);
  }

  //pass ui messages to children SceneObjects , usually used to communicate from dom based ui
    ui_message(cmd: string, msg: string): void {
    super.ui_message(cmd, msg);
  }
}
